<template>
<div>
	<ul class="sub-nav">
		<li class="d-none" v-on:click="handleTab('services')">
			<i class="fas fa-pen-nib fa-fw"></i> PROFESSIONAL SERVICES
			<span class="sub-nav-value">
				Need professional help?
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
		<li v-on:click="handleTab('exports')">
			<i class="material-icons md-18">cloud_download</i> DOWNLOADS (4)
			<span class="sub-nav-value">
				Client Ready PDF
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
		<li v-on:click="handleTab('zoning')" v-bind:class="{inactive:!parcel.zoning || parcel.zoning.length < 1}">
			<i class="material-icons md-18">assignment</i> ZONING ({{parcel.zoning.length}})
			<span v-if="parcel.zoning && parcel.zoning.length > 0" class="sub-nav-value">
				{{subNavShorten(parcel.zoning[0].designation)}}
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
		<li v-for="(category, index) in overlayCategories" v-on:click="handleTab(index)" class="">
			<i class="material-icons md-18">{{getCategoryIcon(index)}}</i> {{index.toUpperCase()}} ({{category.length}})
			<span class="sub-nav-value">
				{{subNavShorten(category[0].name)}}
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>

		<li v-on:click="handleTab('permits')" v-bind:class="{inactive:!parcel.permits || parcel.permits.length < 1}">
			<i class="material-icons md-18">business_center</i> PERMITS ({{parcel.permits.length}})
			<span v-if="parcel.permits && parcel.permits.length > 0" class="sub-nav-value">
				{{subNavShorten(parcel.permits[0].typeRaw)}}
			</span>
			<i class="material-icons md-18 arrow-more">keyboard_arrow_right</i>
		</li>
		
	</ul>
	<div class="category">
		<div class="category-title">
			STATS 
		</div>
		<div class="property-row">
			<label>APN</label>
			<div class="property-value-right">
				<span v-if="parcel.apnFmt !== null">
					{{parcel.apnFmt}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div  class="property-row">
			<label>Lot size</label>
			<div class="property-value-right">
				<span v-if="parcel.geomArea !== null">
					{{lotSizeAcres}} acres 
					<span class="text-muted font-weight-light">|</span> 
					{{lotSizeFt}} SF
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
	</div>

	<div v-if="parcel.owner !== null" class="category">
		<div class="category-title">
			OWNER 
		</div>
		<div v-if="parcel.unlocked === false" v-on:click="unlock" class="lock-block mt-2 mb-2">
			<div class="lock-icon-box">
				<i class="material-icons md-36">lock</i>
			</div>
			<div class="lock-text">
				<h5 class="mb-0 text-white">Unlock to view owner's information</h5>
				<h5 class="mb-0 font-weight-light text-light">${{plans.parcelUnlock.price}} to unlock all info for this parcel</h5>
			</div>
		</div>
		<div v-else class="property-row">
			<label>Contact</label>
			<div class="property-value-right text-right">
				<div>{{parcel.owner.name1}}</div>
				<div>{{parcel.owner.name2}}</div>
				<div>{{parcel.owner.name3}}</div>
				<div>{{parcel.owner.address1}}</div>
				<div>{{parcel.owner.address2}}</div>
				<div>{{parcel.owner.address3}}</div>
				<div>{{parcel.owner.address4}}</div>
				<div>{{parcel.owner.postal}}</div>
			</div>
		</div>
	</div>

	<div class="category">
		<div class="category-title">
			COMMUNITY PLAN
		</div>
		<div class="property-row">
			<label>Name</label>
			<div class="property-value-right">
				<span class="link" v-on:click="routeCommunityPlan(parcel.communityPlan)" 
					v-if="parcel.communityPlan !== null && parcel.communityPlan.name !== null">
					{{parcel.communityPlan.name}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
	</div>

	<div class="category">
		<div class="category-title">
			ASSESSOR
		</div>
		<div class="property-row">
			<label>Land</label>
			<div class="property-value-right">
				<span v-if="parcel.assessor.land !== null">
					{{parcel.assessor.land | currency}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>Improvements</label>
			<div class="property-value-right">
				<span v-if="parcel.assessor.improvements !== null">
					{{parcel.assessor.improvements | currency}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
	</div>

	<div class="category">
		<div class="category-title">
			STRUCTURE
		</div>
		<div class="property-row">
			<label>Effective year built</label>
			<div class="property-value-right">
				<span v-if="parcel.structure.effectiveYearBuilt !== null">
					{{parcel.structure.effectiveYearBuilt}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>Living SF</label>
			<div class="property-value-right">
				<span v-if="parcel.structure.livingSF !== null">
					{{parcel.structure.livingSF | numberWithCommas}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>Usable SF</label>
			<div class="property-value-right">
				<span v-if="parcel.structure.usableSF !== null">
					{{parcel.structure.usableSF | numberWithCommas}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>Units</label>
			<div class="property-value-right">
				<span v-if="parcel.structure.units !== null">
					{{parcel.structure.units}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>Bedrooms</label>
			<div class="property-value-right">
				<span v-if="parcel.structure.bedrooms !== null">
					{{parcel.structure.bedrooms}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>Bathrooms</label>
			<div class="property-value-right">
				<span v-if="parcel.structure.bathrooms !== null">
					{{parcel.structure.bathrooms}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		
	</div>

	<div class="category">
		<div class="category-title">
			SUBDIVISION
		</div>
		<div class="property-row">
			<label>Name</label>
			<div class="property-value-right">
				<span v-if="parcel.subdivision.name !== null">
					{{parcel.subdivision.name}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>Map</label>
			<div class="property-value-right">
				<span v-if="parcel.subdivision.map !== null">
					{{parcel.subdivision.map}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
	</div>

	<div class="category">
		<div class="category-title">
			LEGAL DESCRIPTION
		</div>
		<div class="property-row">
			<label>Description</label>
			<div class="property-value-right">
				<span v-if="parcel.legalDescription !== null">
					{{parcel.legalDescription}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
	</div>

	<div class="category">
		<div class="category-title">
			FIPS CODES
		</div>
		<div class="property-row">
			<label>State</label>
			<div class="property-value-right">
				<span v-if="parcel.stateFIPS !== null">
					{{parcel.stateFIPS}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
		<div class="property-row">
			<label>County</label>
			<div class="property-value-right">
				<span v-if="parcel.countyFIPS !== null">
					{{parcel.countyFIPS}}
				</span>
				<span v-else class="undef">
					-
				</span>
			</div>
		</div>
	</div>

	<div class="property-row">
		<small class="float-right text-muted font-weight-light mt-updated">
			parcel updated {{lastDataCheck | ago}}
			<i class="material-icons md-14">query_builder</i>
		</small>
	</div>

	<div class="sponsored-section">
		<div class="category sponsored-category">
			<div class="font-weight-bold text-light-gray sponsored-head">
				PROFESSIONAL SERVICES
			</div>
		</div>
		<div class="category sponsored-category">
			<h4 class="sponsored-title">
				Development feasibility
			</h4>
			<div class="property-row">
				Looking to further understand the development potential for a property? Have an experienced architect review the municipal code and compile a feasibility study for you.
			</div>
			<div class="property-row overflow-hidden mb-2">
				<a href="tel:+1-619-304-0300" class="btn btn-sm btn-dark float-right">CALL 619-304-0300</a>
			</div>
		</div>
		<div class="category">
			<div class="text-right">
				<small><a v-bind:href="serviceProviderHref()" class="link-gray">
						Are you a service provider?
					</a>
				</small>
			</div>
		</div>
	</div>

</div>
</template>

<script>

import {mapActions} from 'vuex';
import overlayIcons from '../../config/overlay-icons';

export default {
	props: {
		parcel:Object,
		addressId:Number,
		handleTab:Function,
	},
	computed: {
		lotSizeAcres: function(){
			let parcel = this.parcel;
			if (parcel.geomArea === null) return '';
			let acres = parcel.geomArea / 43560;
			if (acres < 100){
				return '≈ '+Number.parseFloat(acres).toPrecision(2);
			} else {
				return '≈ '+Number.parseFloat(acres).toFixed(0);
			}

		},
		lotSizeFt: function(){
			let parcel = this.parcel;
			if (parcel.geomArea === null) return '';
			return '≈ '+Math.round(Number(parcel.geomArea)).toLocaleString();
		},
		token: function(){
			return this.$store.state.agent.token;
		},
		plans:function(){
			return this.$store.state.plan.plans;
		},
		overlayCategories:function(){
			let cats = {};
			this.parcel.overlaySources.forEach((overlay)=>{
				cats[overlay.category] = cats[overlay.category] || [];
				cats[overlay.category].push(overlay);
			});
			return cats;
		},
		lastDataCheck:function(){
			if (this.parcel.sourceLayer && this.parcel.sourceLayer.lastDataCheck) return this.parcel.sourceLayer.lastDataCheck
			return this.parcel.updated
		}
	},
	methods:{
		routeCommunityPlan: function(communityPlan){
			//	update our route which will fetch the community plan
			this.$router.push({
				name: 'community-plans',
				params:{
					id: communityPlan.id
				}
			});
		},
		routeZoning:function(){
			this.$router.push({
				name:'parcels-tab',
				params:{
					id:this.parcel.id,
					tab:'layers'
				}
			});
		},
		unlock: function(){
			this.$router.push({
				name: 'unlock-parcel', 
				params:{
					parcelId: this.parcel.id
				},
				query:{
					addressId: this.addressId
				}
			});
		},
		subNavShorten:function(title){
			if (!title || title.length < 24) return title;
			return title.substr(0,24)+'...';
		},
		...mapActions({
			'setHighlight': 'SET_HIGHLIGHT',
			'setBounds': 'SET_BOUNDS'
		}),
		serviceProviderHref:function(){
			return 'mailto:hello@scoutred.com?subject='+
				encodeURIComponent('Scoutred service provider request')+
				'&body='+
				encodeURIComponent('[tell us about your service]');
		},
		getCategoryIcon:function(category){
			if (overlayIcons[category])
				return overlayIcons[category]
		}
	}
}

</script>

<style>
	#parcel-overview .btn-more{
		position:relative;
		padding:.15rem .25rem;
    	font-size:.75rem;
    	margin-left:.5rem;
	}
	.sponsored-head{
		color: #8FA3AE;
		font-weight: 700;
		font-size:0.8rem;
	}
	.sponsored-section{
		margin:1rem -1rem -1rem -1rem;
		background-color:#f8f9fa;
		padding:1rem;
	}
	.sponsored-title{
		font-size:1rem;
		margin-bottom:0;
	}
	.sponsored-category .property-row{
		font-size:0.8rem;
	}
	.sponsored-category{
		border-bottom:1px solid #E0E0E0;
		margin-bottom:1rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/parcel/parcel-overview.vue